import FJAiVideoDubRightSuccess from '../view/FJAiVideoDubRightSuccess';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import FJActionAiVideoDub from '../../../../redux/action/FJActionAiVideoDub';
import { useCallback } from 'react';
import FJConstant from '../../../../constants/FJConstant';

const FJAiVideoDubRightSuccessContainer = ({ isShow }) => {
    const dispatch = useDispatch();
    const headerTabIndex = useSelector(state => state.common.headerTabIndex);
    const resultInfo = useSelector(state => state.aiVideoDub.resultInfo);
    const audioWavesurferUrl = useSelector(state => state.aiVideoDub.audioWavesurferUrl);
    const resultAudioInfoStatus = useSelector(state => state.aiVideoDub.resultAudioInfoStatus);
    const isShowTrimVideo = useSelector(state => state.modals.videoTrimModelData.display);

    const updateAudioWavesurferUrl = useCallback(
        viewSize => {
            if (resultAudioInfoStatus !== FJConstant.SUCCESS) {
                return;
            }

            dispatch(FJActionAiVideoDub.updateAudioWavesurferUrlAction(viewSize));
        },
        [dispatch, resultAudioInfoStatus],
    );

    const retryAudio = useCallback(() => {
        dispatch(FJActionAiVideoDub.separateAudioAction());
    }, [dispatch]);

    return (
        <FJAiVideoDubRightSuccess
            isShow={isShow && headerTabIndex === 0}
            audioWavesurferUrl={audioWavesurferUrl}
            resultInfo={resultInfo}
            updateAudioWavesurferUrl={updateAudioWavesurferUrl}
            resultAudioInfoStatus={resultAudioInfoStatus}
            retryAudio={retryAudio}
            isShowTrimVideo={isShowTrimVideo}
        />
    );
};

FJAiVideoDubRightSuccessContainer.propTypes = {
    isShow: PropTypes.bool.isRequired,
};

export default FJAiVideoDubRightSuccessContainer;
